var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSubjects = function SvgIconSubjects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-subjects"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M151.284 136.8v11h-2v13h18a4 4 0 0 0 4-4v-20Z",
    transform: "translate(-147.284 -136.799)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    d: "M0 0h4v11a2 2 0 0 1-2 2 2 2 0 0 1-2-2V0Z",
    transform: "translate(0 11)",
    fill: "#6a6a6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M156.284 141.8h10a1 1 0 0 1 0 2h-10a1 1 0 0 1 0-2Z",
    transform: "translate(-147.284 -136.799)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M156.284 145.8h10a1 1 0 0 1 0 2h-10a1 1 0 0 1 0-2Z",
    transform: "translate(-147.284 -136.799)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M156.284 149.8h10a1 1 0 0 1 0 2h-10a1 1 0 0 1 0-2Z",
    transform: "translate(-147.284 -136.799)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M155.95 153.8h6.667c.367 0 .667.45.667 1s-.3 1-.667 1h-6.667c-.366 0-.666-.45-.666-1s.3-1 .666-1Z",
    transform: "translate(-147.284 -136.799)",
    fill: "#f2f2f2"
  }))));
};
export { SvgIconSubjects as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8ZyBpZD0iaWNvbi1zdWJqZWN0cyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSI+CiAgICA8cGF0aCBpZD0iUGF0aF8xMTEiIGRhdGEtbmFtZT0iUGF0aCAxMTEiIGQ9Ik0xNTEuMjg0LDEzNi44djExaC0ydjEzaDE4YTQsNCwwLDAsMCw0LTR2LTIwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE0Ny4yODQgLTEzNi43OTkpIiBmaWxsPSIjYTBhMGEwIi8+CiAgICA8cGF0aCBpZD0iUmVjdGFuZ2xlXzI1IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAyNSIgZD0iTTAsMEg0QTAsMCwwLDAsMSw0LDBWMTFhMiwyLDAsMCwxLTIsMkgyYTIsMiwwLDAsMS0yLTJWMEEwLDAsMCwwLDEsMCwwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxMSkiIGZpbGw9IiM2YTZhNmEiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzExMiIgZGF0YS1uYW1lPSJQYXRoIDExMiIgZD0iTTE1Ni4yODQsMTQxLjhoMTBhMSwxLDAsMCwxLDAsMmgtMTBhMSwxLDAsMCwxLDAtMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNDcuMjg0IC0xMzYuNzk5KSIgZmlsbD0iI2YyZjJmMiIvPgogICAgPHBhdGggaWQ9IlBhdGhfMTEzIiBkYXRhLW5hbWU9IlBhdGggMTEzIiBkPSJNMTU2LjI4NCwxNDUuOGgxMGExLDEsMCwwLDEsMCwyaC0xMGExLDEsMCwwLDEsMC0yWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE0Ny4yODQgLTEzNi43OTkpIiBmaWxsPSIjZjJmMmYyIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8xMTQiIGRhdGEtbmFtZT0iUGF0aCAxMTQiIGQ9Ik0xNTYuMjg0LDE0OS44aDEwYTEsMSwwLDAsMSwwLDJoLTEwYTEsMSwwLDAsMSwwLTJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTQ3LjI4NCAtMTM2Ljc5OSkiIGZpbGw9IiNmMmYyZjIiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzExNSIgZGF0YS1uYW1lPSJQYXRoIDExNSIgZD0iTTE1NS45NSwxNTMuOGg2LjY2N2MuMzY3LDAsLjY2Ny40NS42NjcsMXMtLjMsMS0uNjY3LDFIMTU1Ljk1Yy0uMzY2LDAtLjY2Ni0uNDUtLjY2Ni0xUzE1NS41ODQsMTUzLjgsMTU1Ljk1LDE1My44WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE0Ny4yODQgLTEzNi43OTkpIiBmaWxsPSIjZjJmMmYyIi8+CiAgPC9nPgo8L3N2Zz4K";